var render = function () {
  var _vm$summary$order, _vm$summary$order2, _vm$summary$message;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "max-width": "1200"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "나누리상품권 주문 매출",
      "showsFilterButton": ""
    },
    model: {
      value: _vm.showsSearch,
      callback: function callback($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('nshop-viewer-statistics-search', _vm._b({}, 'nshop-viewer-statistics-search', {
    showsSearch: _vm.showsSearch,
    loading: _vm.loading
  }, false)), _c('v-row', {
    staticClass: "ma-n2 mt-n1"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('list-widget', {
    attrs: {
      "title": "추천인"
    }
  }, [_c('b', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s((_vm.summary.totalCount || 0).format()) + " ")]), _vm._v(" 개 ")])], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('list-widget', {
    attrs: {
      "title": "총 매출금액"
    }
  }, [_c('b', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s((((_vm$summary$order = _vm.summary.order) === null || _vm$summary$order === void 0 ? void 0 : _vm$summary$order.sales) || 0).format()) + " ")]), _vm._v(" 원 ")])], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('list-widget', {
    attrs: {
      "title": "총 주문건수"
    }
  }, [_c('b', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s((((_vm$summary$order2 = _vm.summary.order) === null || _vm$summary$order2 === void 0 ? void 0 : _vm$summary$order2.count) || 0).format()) + " ")]), _vm._v(" 건 ")])], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('list-widget', {
    attrs: {
      "title": "총 발송건수"
    }
  }, [_c('b', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s((((_vm$summary$message = _vm.summary.message) === null || _vm$summary$message === void 0 ? void 0 : _vm$summary$message.count) || 0).format()) + " ")]), _vm._v(" 건 ")])], 1), _c('v-spacer'), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('list-excel', _vm._g({
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-card', {
          staticStyle: {
            "overflow": "hidden"
          },
          attrs: {
            "outlined": ""
          }
        }, [_c('v-btn', _vm._g(_vm._b({
          staticClass: "text-caption green--text",
          staticStyle: {
            "margin": "-1px"
          },
          attrs: {
            "height": "40",
            "color": "white",
            "elevation": "0"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          loading: _vm.loading
        }), false), on), [_c('v-icon', [_vm._v(" mdi-microsoft-excel ")]), _c('span', [_vm._v(" 엑셀다운로드 ")])], 1)], 1)];
      }
    }])
  }, {
    excel: _vm.excel
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', _vm._b({
    ref: "data-table",
    staticClass: "v-sheet--outlined",
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "mobile-breakpoint": "880"
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref2) {
          var value = _ref2.value,
              item = _ref2.item;
          return [_c('span', {
            key: index,
            attrs: {
              "title": header.withTitle ? header.formatter.bind(item)(value, item) : undefined
            },
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    }), {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item._id ? [_c('v-btn', {
          staticClass: "pa-0 caption",
          attrs: {
            "x-small": "",
            "text": "",
            "tile": "",
            "title": "해당 추천인의 주문 조회",
            "to": {
              path: '/console/nshop/orders',
              query: {
                _viewer: item._id
              }
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-receipt-text")])], 1), _c('v-btn', {
          staticClass: "pa-0 caption",
          attrs: {
            "x-small": "",
            "text": "",
            "tile": "",
            "title": "해당 추천인의 기간별 통계",
            "to": {
              path: '/console/nshop/statistics',
              query: {
                _viewer: item._id
              }
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chart-timeline-variant")])], 1)] : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('v-divider'), _c('v-pagination', {
          staticClass: "my-2",
          attrs: {
            "value": _vm.page,
            "length": _vm.pageCount,
            "total-visible": 11,
            "color": "primary"
          },
          on: {
            "input": function input(page) {
              return _vm.$router.push({
                query: Object.assign({}, _vm.$route.query, {
                  page: page
                })
              });
            }
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false))], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }